import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import assign from 'object-assign';
import { Form as FormsyForm } from 'formsy-react';
import LinearProgress from 'material-ui/LinearProgress';
import Snackbar from 'material-ui/Snackbar';
import FormAppBar from './FormAppBar';
import AppStore from '../../stores/AppStore';


const Form = React.createClass({


    getChildContext: function() {
        return {
            canSubmit: this.state.canSubmit, onSave: this.onSave,
            onCancel: this.onCancel
        };
    },
    getInitialState: function() {
        return {
            successMessageDuration: 1500,
            showSuccessMessage: false,
            showErrorMessage: false,
            showProgress: false,
            canSubmit: false,
            lastErrorMessage: ''
        };
    },
    componentDidMount: function() {
        AppStore.addFormSubmitErrorListener(this.onFormSubmitError);
        AppStore.addFormSubmitSuccessListener(this.onFormSubmitSuccess);
    },
    componentWillUnmount: function() {
        AppStore.removeFormSubmitErrorListener(this.onFormSubmitError);
        AppStore.removeFormSubmitSuccessListener(this.onFormSubmitSuccess);
    },

    render: function() {

        let progressBar;

        if (this.state.showProgress) {
            progressBar = <LinearProgress mode="indeterminate" />;
        }

        return (

            <FormsyForm
                ref="form"
                className="form"
                onValid={this.onFormValid}
                onInvalid={this.onFormInvalid}
                onValidSubmit={this.onSave}
                onInvalidSubmit={this.onFormInvalid}
                validationErrors={this.props.validationErrors}
            >
                <div className='cent-main'>
                <FormAppBar
                    title={this.props.title}
                    submitButtonLabel={this.props.submitButtonLabel}
                />

                    <div className='cent-form'>
                    {progressBar}
                    {this.props.children}
                    </div>
                </div>
            <Snackbar
                open={this.state.showSuccessMessage}
                message="Saved"
                autoHideDuration={this.state.successMessageDuration}
                onRequestClose={this.handleSnackbarRequestClose}
            />
            <Snackbar
                open={this.state.showErrorMessage}
                message={this.state.lastErrorMessage}
                action="OK"
                onActionTouchTap={this.handleSnackbarRequestClose}
                onRequestClose={this.handleSnackbarRequestClose}
            />
            </FormsyForm>
        )
    },
    onSave: function(data) {
        // remove extra fields like those generated by the MulticheckboxSet
        // these fields should start with underscore
        for(const field in data) {
            if(data.hasOwnProperty(field) && field.match(/^_/)) {
                delete data[field];
            }
        }
        this.setState(assign({}, this.state, { canSubmit: false, showProgress: true } ));
        if (this.props.onSave(data)) {
            this.setState(assign({}, this.state, { canSubmit: false, showProgress: false } ));
        }
    },
    onCancel: function() {
        browserHistory.goBack();
    },
    onFormValid: function() {
        this.setState(assign({}, this.state, { canSubmit: true } ));
    },
    onFormInvalid: function(model, resetForm, invalidateForm) {
        this.setState(assign({}, this.state, { canSubmit: false } ));
    },
    handleSnackbarRequestClose: function() {
        this.setState(assign({}, this.state, { showSuccessMessage: false, showErrorMessage: false } ));
    },
    onFormSubmitError: function() {
        this.setState(assign({}, this.state, { showProgress: false, showErrorMessage: true, lastErrorMessage: AppStore.getLastError() } ));
        if (!!this.props.onError) {
            this.props.onError(this.state.lastErrorMessage);
        }
    },
    onFormSubmitSuccess: function() {

        let state = {...this.state};
        state.showProgress = false;
        if (!this.props.suppressSuccessMessage) {
            state.showSuccessMessage = true;
        }

        this.setState(assign({}, this.state, state ));

        if (!!this.props.suppressRedirect) {
            return;
        }

        if(this.props.redirectTo) {
            browserHistory.replace(this.props.redirectTo);
        }
        browserHistory.goBack();
    }

});

Form.propTypes = {
    onSave: PropTypes.func.isRequired,
    successEvent: PropTypes.string,
    errorEvent: PropTypes.string,
    onError: PropTypes.func,
    suppressRedirect: PropTypes.bool,
    suppressSuccessMessage: PropTypes.bool,
    submitButtonLabel: PropTypes.string,
};

Form.childContextTypes = {
    canSubmit: PropTypes.bool,
    onSave: PropTypes.func,
    onCancel: PropTypes.func
};

export default Form;
